export const isPreRegistered = (id, preRegisteredUsers) => {
    return preRegisteredUsers.some((student) => student.id === id);
  };